import { createFileRoute } from "@tanstack/react-router";

import { BaseEditCreateModal } from "@/components/_Modals/BaseEditCreateModal";
import { CompanyForm } from "@/features/dashboard/empresas/_components/CompanyForm";

export const Route = createFileRoute("/_private/dashboard/_base/empresas/cadastrar/modal")({
  component: ModalNewOrder
});

function ModalNewOrder() {
  return (
    <BaseEditCreateModal title="Cadastrar Empresa" from="/dashboard/empresas/editar/$id">
      <CompanyForm />
    </BaseEditCreateModal>
  );
}
